import ipfs from "decentralized/Ipfs.js";
import {lstorage} from 'utils/lstorage.js';
import ethereum from "decentralized/ethereum.js";
import {PAD} from './pack-types.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {web3} from 'decentralized/web3.js';
import {PACKS} from 'decentralized/transactions/contracts.js';
import EthereumTransaction from "decentralized/transactions/EthereumTransaction.js";
import {NewPack, PackHasContent} from 'decentralized/EthereumEvents.js';
import PacksContract from 'decentralized/contracts/PacksContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';

let INCLUDED_IN = {};

export const newPack = (title, description, samples, presets, previousHash, obj) => {
    return new Promise(async (resolve) => {
        let json = {
            samples,
            presets,
            description,
            title,
            ... obj
        };
        
        let packHash = await ipfs.addJson(json);
        resolve(packHash);
        
        console.log("saving pack PREVIOUS HASH =", previousHash);
        let _prevHash = web3.utils.padLeft('0x0',64);
        if (previousHash) {
            _prevHash = ipfsHashToBytes32(previousHash);
        }
        
        /*
        storeLocally({
            title,
            previousHash,
            packHash
        });
        */
        
        
        if (json.type === PAD) {
            await ethereum.xanadu.syncPadType(packHash, PAD);
        }
        
        
        let content = [... samples, ...presets].filter(x => x);
        new EthereumTransaction(
            PACKS,
            'newPack',
            [
                ipfsHashToBytes32(packHash),
                _prevHash,
                content.map(ipfsHashToBytes32),
                web3.utils.fromAscii(title),
            ])
            .execute();
    });
};

export const getPacks = async () => {
    let query = new BackendQuery(new PacksContract().contractAddress)
        .select("packHash")
        .select("previousHash")
        .select("title")
        .from(NewPack);
    let results = await query.executeQuery();
    let localPacks = updateLocalPacks(results, getLocalPacks());

    let p =collapseEdits([... localPacks, ...results]);

    for (let pack of p) {
        pack.matchingContent = undefined;
    }
    return p;
};

export const getPacksIncludedIn = async (contentHash) => {
    if (contentHash in INCLUDED_IN) {
        return INCLUDED_IN[contentHash];
    }
    let packs = await getPacks();
    let query = new BackendQuery(new PacksContract().contractAddress)
        .select("packHash")
        .where("contentHash", contentHash)
        .whereIn("packHash", packs.map(x => x.packHash))
        .from(PackHasContent);
    let results = await query.executeQuery();
    for (let r of results) {
        let pack = packs.find(p => r.packHash === p.packHash);
        if (pack) {
            r.title = pack.title;
        }
    }
    INCLUDED_IN[contentHash] = results;
    return results;
};

const collapseEdits = (results) => {
    let toDelete = results.filter(
        x => x.previousHash)
        .map(x => x.previousHash);
    return results.filter(
        x => !toDelete.includes(x.packHash));
};

const storeLocally = (pack) => {
    lstorage.setItem(
        "local_packs",
        JSON.stringify([
            ... getLocalPacks(),
            pack]));
};

const getLocalPacks = () => {
   let localPacks = lstorage.getItem("local_packs");
    if (!localPacks) {
        localPacks = [];
    } else {
        localPacks = JSON.parse(localPacks);
    }
    return localPacks;
};

const updateLocalPacks = (results, local) => {
    // see if any of the local packs exist in results
    // if so remove 
    let _local = local.filter(
        pack => !results.some(x => x.packHash === pack.packHash));

    lstorage.setItem("local_packs", JSON.stringify(_local));
    return _local;
};

export const savePad = (name, pad) => {
    // get samples from pad
    let samples = [];
    let presets = [];

    for (let track of pad.slotTracks) {
        if (track.sample) {
            samples.push(track.sample.getId());
        } else if (track.preset) {
            if (track.preset.contentHash) {
                presets.push(track.preset.contentHash);
            }
        }
    }

    let obj = {
        type: PAD,
        pad: pad.getJsonForPack(),
        fx: pad.effectRack.getJson()
    };

    newPack(name, "", samples, presets, undefined, obj);
};
